import { useUpdateVoucherCode } from '@customink/project-service-react-components';
import { SYNC_STRATEGIES } from '@customink/project-service-types';
import { useCallback } from 'react';

export const useUpdateVoucherCodeSync = () => {
  const [trigger, result] = useUpdateVoucherCode();
  const curriedTrigger = useCallback(
    (voucherCode: string) =>
      trigger({ voucherCode, syncStrategy: SYNC_STRATEGIES.CORE_ORDER }),
    [trigger],
  );
  return [curriedTrigger, result] as const;
};
